import '.ah{flex-shrink:0;}.ssr-plugin'
import '.aa{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.ak{height:100%;}.ssr-plugin'
import '.b6{border:none;}.ssr-plugin'
import '.cm{background-color:transparent;}.ssr-plugin'
import '.cn{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.bj{position:sticky;}.ssr-plugin'
import '.co{top:4rem;}.ssr-plugin'
import '.cp{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.cq{padding-bottom:1rem;}.ssr-plugin'
import '.cr{margin-bottom:1rem;}.ssr-plugin'
import '.cs{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.bk{top:0px;}.ssr-plugin'
import '.bs{left:0px;}.ssr-plugin'
import '.bt{right:0px;}.ssr-plugin'
import '.bu{bottom:0px;}.ssr-plugin'
import '.ct{z-index:9999;}.ssr-plugin'
import '.cu{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bo{justify-content:flex-end;}.ssr-plugin'
import '.al{flex:1;}.ssr-plugin'
import '.c3{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ah aa l ak b6 cm cn"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b a8"
    >
      <div className="bj co cp t cq cr cs a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="f bk bs bt bu ct t cu a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aa a bo cs"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="al c3">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
